module.exports = __webpack_public_path__ + "static/media/icon_wifi-drop.2d3767df.svg";